import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {

  connect(){
    super.connect();
    this.bindChangeDateFilter();
    this.bindResetFilter();
  }

  datatableLayout(){
    return {
      scroll: true,
      footer: false,
    }
  }

  datatableSearch(){
    return {
      input: $('#kt_users_search_query'),
      delay: 400,
      key: 'search'
    }
  }

  datatableFilter(){
    $('#kt_users_search_role').on('change', function(e) {
      this.datatable.search(e.target.value, e.target.dataset.paramName);
    }.bind(this));

    $('#kt_users_search_status').on('change', function(e) {
      this.datatable.search(e.target.value, e.target.dataset.paramName);
    }.bind(this));

    $('#kt_users_search_subscriptions').on('change', function(e) {
      this.datatable.search(e.target.value, e.target.dataset.paramName);
    }.bind(this));
  }

  bindResetFilter(){
    $('#kt_users_reset_filter').on('click', function() {
      $('#kt_users_search_query').val('');
      $('#kt_users_search_role').val('').trigger('change.select2');
      $('#kt_users_search_status').val('').trigger('change.select2');
      $('#kt_users_search_subscriptions').val('').trigger('change.select2');
      $('#kt_users_daterangepicker').find('.daterange-label').html('Tgl Bergabung');

      this.datatable.setDataSourceParam('daterange', '');
      this.datatable.setDataSourceParam('query', {});
      this.datatable.load();
    }.bind(this));
  }

  bindChangeDateFilter(){
    var el = $('#kt_users_daterangepicker');
    if (el.length === 0) return;

    var start = moment().subtract(29, 'days');
    var end = moment();

    function cb(s, e) {
      el.find('.daterange-label').html(s.format('DD MMM') + ' - ' + e.format('DD MMM'));
    }

    el.daterangepicker({
      startDate: start,
      endDate: end,
      opens: 'left',
      autoUpdateInput: false,
      applyClass: 'btn-primary',
      cancelClass: 'btn-light-primary',
      locale: { cancelLabel: 'Reset' },
      ranges: {
        '7 Hari Terakhir': [moment().subtract(6, 'days'), moment()],
        '30 Hari Terakhir': [moment().subtract(29, 'days'), moment()],
        'Bulan Ini': [moment().startOf('month'), moment().endOf('month')],
        'Bulan Lalu': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    });

    el.on('apply.daterangepicker', function(e, picker) {
      cb(picker.startDate, picker.endDate);
      this.datatable.setDataSourceParam('daterange', `${picker.startDate.format("DD/MM/YYYY")}-${picker.endDate.format("DD/MM/YYYY")}`);
      this.datatable.load();
    }.bind(this));

    el.on('cancel.daterangepicker', function() {
      el.find('.daterange-label').html('Tgl Bergabung');
      this.datatable.setDataSourceParam('daterange', '');
      this.datatable.load();
    }.bind(this));
  }

  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 40,
        type: 'number',
        selector: false,
        textAlign: 'left',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'created_at',
        title: 'Tgl Bergabung',
        sortable: true,
        autoHide: false,
        width: 160,
        template: function(data) {
          return `
            <span class="font-weight-bolder">${data.joined_at}</span>
            <span data-controller="base--popover" data-base--popover-html="1" data-base--popover-trigger="hover" data-title="Detail Tanggal" data-content="<b>Bergabung:</b> ${data.uc_created_at}<br/><b>Terakhir diubah:</b> ${data.uc_updated_at}<br/><b>Akun dibuat:</b> ${data.user_created_at}<br/><b>Akun diubah:</b> ${data.user_updated_at}" class="svg-icon svg-icon-light-dark ml-1" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 24 24">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24"/>
                  <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                  <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                  <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                </g>
              </svg>
            </span>
          `;
        }
      },
      {
        field: 'name',
        title: 'Nama',
        sortable: true,
        autoHide: false,
        overflow: 'visible',
        width: 240,
        template: function(data) {
          return `
            <div style="line-height:1.4;">
              <span style="font-size:0.85em;color:#999;">${data.email}</span><br/>
              <span class="font-weight-bolder">${data.name}</span>
            </div>
          `;
        }
      },
      {
        field: 'role',
        title: 'Role',
        sortable: false,
        autoHide: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.role}</span>`;
        }
      },
      {
        field: 'subscriptions',
        title: 'Subscribe',
        sortable: false,
        autoHide: false,
        width: 100,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.subscriptions}</span>`;
        }
      },
      {
        field: 'status',
        title: 'Status',
        sortable: true,
        autoHide: false,
        width: 160,
        template: function(data) {
          if (data.status == "registered"){
            return `<span class='label label-success label-inline mr-2 mb-2' style='height: fit-content;font-size: 13px;'>
              Terdaftar
            </span>`
          } else {
            return `<span class='label label-warning label-inline mr-2 mb-2' style='height: fit-content;font-size: 13px;'>
              Menunggu Konfirmasi
            </span>`
          }
        }
      },
      {
        field: 'action',
        title: 'Aksi',
        sortable: false,
        width: 80,
        autoHide: false,
        template: function(data) {
          return `
            <a href="${data.delete_path}" data-method="delete" data-confirm="Apakah anda yakin ingin menghapus akun ini?" class="btn btn-sm btn-clean btn-icon" title="Delete">
              <i class="la la-trash text-danger"></i>
            </a>
          `;
        }
      },
    ]
  }
}
